import type { Task } from "@/types/task.ts";
import { CompletionStatus } from "@utils/completion_status.ts";

export const mockTasks: Task[] = [
  {
    id: 1,
    taskable_id: 1,
    taskable_type: "SetupQuickApplyProfile",
    status: CompletionStatus.NotStarted,
  },
  {
    id: 2,
    taskable_id: 2,
    taskable_type: "SetupWorkPreference",
    status: CompletionStatus.NotStarted,
  },
  {
    id: 3,
    taskable_id: 3,
    taskable_type: "SetupAccount",
    status: CompletionStatus.NotStarted,
  },
];
